import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-get-extension',
    templateUrl: './get-extension.component.html',
    styleUrls: ['./get-extension.component.scss'],
    standalone: false
})
export class GetExtensionComponent {
  constructor(
    public dialogRef: MatDialogRef<GetExtensionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  openExtensionStore() {
    window.open(
      'https://chromewebstore.google.com/detail/medical-nuagedx-navigatio/nnholfbdngmojjamhhpicimmbicbfepi',
      '_blank'
    );
    this.closeDialog();
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
